"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=fin-posting-rule.dto.js.map